import { inject } from "@vercel/analytics";
import { injectSpeedInsights } from "@vercel/speed-insights";

/**
 * Drop query and fragment before an event leaves the browser. The app
 * carries one-time secrets there (``#claim=``, trial and reset tokens),
 * and the traffic and speed reports only need the path.
 */
export function stripUrlSecrets<T extends { url: string }>(event: T): T {
  const url = new URL(event.url);
  return { ...event, url: `${url.origin}${url.pathname}` };
}

/**
 * Vercel Web Analytics and Speed Insights (free tier, KAN-2033) —
 * production builds on Vercel only. Elsewhere (preview, local, e2e)
 * ``/_vercel/insights/*`` and ``/_vercel/speed-insights/*`` do not exist
 * and the tags would only add a 404 to the console.
 */
export function initWebAnalytics(): void {
  if (import.meta.env.VITE_VERCEL_ENV !== "production") return;
  inject({ mode: "production", beforeSend: stripUrlSecrets });
  injectSpeedInsights({ beforeSend: stripUrlSecrets });
}
